import { useContext, useEffect, useState } from "react";
import { TableContext, TeamContext, UserContext } from "../../../context";
import { IPlayer } from "../../../interfaces";
import { Phase } from "../../../util/enums";
import { DilemmaOwnerFirstPersonViewCrown } from "../../molecules";

const FirstPersonViewUserImage = () => {
    const { game } = useContext(TeamContext);
    const { playersInNewOrder } = useContext(UserContext);
    const { theIndexOfTheUserPositionedAt270Degrees, userAngles } = useContext(TableContext);
    const [playerOn270Degrees, setPlayerOn270Degrees] = useState<IPlayer>({
        color: "",
        fullName: "",
        nickname: "",
        email: "",
        image: "",
        isReady: true
    });
    const { isJokerButtonHovered } = useContext(TableContext);
    const isTheUserOn270DegreesDilemmaOwner = playerOn270Degrees ? playerOn270Degrees.email === game?.gameInfo.currentPlayerEmail: false;

    useEffect(() => {
        if (playersInNewOrder)
            setPlayerOn270Degrees(playersInNewOrder[theIndexOfTheUserPositionedAt270Degrees]);
    }, [userAngles, theIndexOfTheUserPositionedAt270Degrees, playersInNewOrder]);

    if (!playerOn270Degrees)
        return <div></div>

    if (!playerOn270Degrees.email)
        return <div></div>

    return (
        <div className={`first_person_view_user_image_wrapper ${isJokerButtonHovered && "remove_an_element_gradually"} ${game?.phase === Phase.QUESTION_CARD && "display_none"} `} >
            <div className="position_to_the_bottom">
                <div className="full_width center_horizontally_and_vertically">
                    <div>
                        <div style={{ position: "relative" }}>
                            <div className="position_dilemma_owner_crown">
                                <div className="first_person_view_user_crown_wrapper">
                                    {isTheUserOn270DegreesDilemmaOwner && <DilemmaOwnerFirstPersonViewCrown playerColor={playerOn270Degrees.color} />}
                                </div>
                            </div>

                            <img
                                className={`first_person_view_user_image border_color_${playerOn270Degrees.color}`}
                                src={`${process.env.REACT_APP_BACKEND_URL}images/${playerOn270Degrees.email}.png`}
                                alt="Profile Icon"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FirstPersonViewUserImage;